import type {HeaderDataPayload} from '@ds/types';

import {InfoCircleOutlined} from '@ant-design/icons';
import {BottomSheet, Loading} from '@ds/components';
import {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from 'store';
import {getBranches} from 'store/slices/dashboard/thunk';

import ChortkeHelp from './components/ChortkeHelp/ChortkeHelp';
import ChortkeTools from './components/ChortkeTools/ChortkeTools';

type ChortkeProps = {
  headerData?: (data: HeaderDataPayload) => void;
};

const Chortke: React.FC<ChortkeProps> = ({headerData}) => {
  const dispatch = useAppDispatch();
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const {selectedVendor, loadingBranches} = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!selectedVendor) {
      void dispatch(getBranches({page: 0, pageSize: 10}));
    }
  }, [dispatch, selectedVendor]);

  useEffect(() => {
    headerData?.({
      icon: <InfoCircleOutlined aria-hidden />,
      action: () => setIsHelpOpen(true),
      iconTitle: 'راهنما'
    });
  }, [headerData]);

  return (
    <>
      {loadingBranches ? (
        <div className="flex min-h-0 flex-1 items-center justify-center">
          <Loading size="large" />
        </div>
      ) : (
        <ChortkeTools vendorId={selectedVendor?.id} />
      )}

      <BottomSheet
        show={isHelpOpen}
        onClose={() => setIsHelpOpen(false)}
        defaultHeader
        title="چرتکه چه کمکی به شما می‌کنه؟"
      >
        <ChortkeHelp onClose={() => setIsHelpOpen(false)} />
      </BottomSheet>
    </>
  );
};

export default Chortke;
